var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lpo)?_c('div',{staticClass:"selected-lpo"},[_c('CurrentLpoHeader'),_c('div',{staticClass:"selected-lpo__content-container"},[_c('div',{staticClass:"selected-lpo__content"},[_c('router-view')],1)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }